import { Component, Input } from '@angular/core';

import { LessonCompSettings } from './lessons.clases';

@Component({
  selector: 'app-lesson-component',
  template: '<div>no template</div>',
  standalone: true,
})
// This is the base class for all the components that are going to be used in the lessons.
export class LessonDynamicComponent {
  @Input() settings: LessonCompSettings = {} as LessonCompSettings;
}
